<template>
  <v-card :loading="loading" v-bind="$attrs" v-on="$listeners">
    <v-card-title class="headline">Active Participants</v-card-title>
    <v-card-subtitle>
      <span
        v-if="
          this.selectedFiscalYear && this.selectedFiscalYear.fiscalYearStart && this.selectedFiscalYear.fiscalYearEnd
        "
        ><b
          >({{ this.selectedFiscalYear.fiscalYearStart | formatDateClient("MM/DD/YYYY", selectedClient) }} -
          {{ this.selectedFiscalYear.fiscalYearEnd | formatDateClient("MM/DD/YYYY", selectedClient) }})</b
        ><br
      /></span>

      Active participants in the program!<br
    /></v-card-subtitle>
    <v-card-text class="display-2 text-center" v-if="!loading">
      {{ count | toNumber }}
    </v-card-text>
    <v-card-actions v-if="showActions">
      <v-spacer></v-spacer>
      <v-btn color="primary" :to="{ name: 'cprParticipantManagement', query: { active: 1 } }">Manage</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";

export default {
  name: "AdminParticipantsWidget",
  props: {
    showActions: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      count: 0,
      loading: true
    };
  },
  mounted() {
    // no need to fetch data during mounting because it is driven by fiscal year being watched
  },
  watch: {
    selectedFiscalYear() {
      this.fetchData();
    },
    selectedProgram() {
      this.fetchData();
    }
  },
  computed: {
    ...mapGetters(["selectedProgram", "selectedClient", "selectedFiscalYear"])
  },
  methods: {
    fetchData() {
      this.loading = true;

      let isCurrentFiscalYear = this.selectedFiscalYear.fiscalYear == moment().year();
      let filters = {
        statuses: [{ name: "PRE" }, { name: "ENR" }]
      };
      if (!isCurrentFiscalYear) {
        filters.effectiveFrom = this.selectedFiscalYear.fiscalYearStart;
        filters.effectiveTo = this.selectedFiscalYear.fiscalYearEnd;
      }

      this.$api
        .post("/api/participants/search?size=1", filters)
        .then(({ data }) => {
          this.count = data.totalElements;
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
